<template>
  <div class="wysiwyg-editor-field">
    <QuillDescriptionEditor
      :value="value"
      :id="fieldKey"
      :options="editorOption"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import QuillDescriptionEditor from "@/components/vue-quill-editor/descriptionEditor.vue";

export default {
  name: "WysiwygEditor",

  components: { QuillDescriptionEditor },

  props: {
    value: { type: String, default: "" },
    fieldKey: { type: String, default: "" },
    field: { type: Object, default: () => ({}) },
    form: { type: Object, default: () => ({}) },
    parentValue: { type: Object, default: null },
    parentFormKey: { type: String, default: "" },
  },

  data() {
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "underline", "strike", "italic"],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ align: [] }],
              [{ color: [] }, { background: [] }],
              ["image"],
              ["video"],
              ["link"],
              ["clean"],
            ],
          },
          imageResize: {
            modules: ["Resize", "DisplaySize"],
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.wysiwyg-editor-field {
  width: 100%;
  ::v-deep {
    .quill-editor .ql-container {
      height: 400px;
    }
    .ql-snow .ql-color-picker .ql-picker-options {
      width: auto;
    }
  }
}
</style>
